import React from "react";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * AreaSidebar
 * Componente que renderiza a lista de Áreas no painel lateral do layout Master-Detail.
 */
const AreaSidebar = ({
    areas,
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {

    // Função para renderizar cada item da lista (injetada no MasterSidebar)
    const renderAreaItem = (area, isActive) => (
        <div className="d-flex align-items-start w-100 overflow-hidden">
            <div className="flex-shrink-0 me-3">
                {area.photoUrl ? (
                    <img
                        src={area.photoUrl}
                        alt={area.name}
                        className="img-fluid rounded-circle shadow-sm"
                        style={{ objectFit: 'cover', width: '32px', height: '32px' }}
                    />
                ) : (
                    <i className="mdi mdi-camera text-primary font-size-24 mt-1"></i>
                )}
            </div>
            <div className="text-start flex-grow-1 overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                    <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                        {area.name}
                    </p>
                    {area.status !== GLOBAL_STATUS.ACTIVE && (
                        <i className="mdi mdi-eye-off-outline text-muted" style={{ fontSize: '14px' }} title="Inativo"></i>
                    )}
                </div>
                <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                    {area.width}m x {area.length}m
                </span>
            </div>
        </div>
    );

    return (
        <MasterSidebar
            title="Locais / Áreas"
            subtitle={`${areas.length} áreas cadastradas`}
            items={areas}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar área..."
            icon="mdi mdi-map-marker-path"
            renderItem={renderAreaItem}
            loadingMessage="Carregando espaços e áreas..."
        />
    );
};

AreaSidebar.propTypes = {
    areas: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default AreaSidebar;
